var TechSpaceErrorType = /* @__PURE__ */ ((TechSpaceErrorType2) => {
  TechSpaceErrorType2["Size"] = "Size";
  TechSpaceErrorType2["NoSpaceLeft"] = "NoSpaceLeft";
  TechSpaceErrorType2["NoQuantityInfo"] = "NoQuantityInfo";
  TechSpaceErrorType2["NoLevelInfo"] = "NoLevelInfo";
  TechSpaceErrorType2["NotImplementedProperty"] = "NotImplementedProperty";
  TechSpaceErrorType2["NoLocationInfo"] = "NoLocationInfo";
  TechSpaceErrorType2["ZeroQuantityNeeded"] = "ZeroQuantityNeeded";
  TechSpaceErrorType2["Unknown"] = "Unknown";
  return TechSpaceErrorType2;
})(TechSpaceErrorType || {});
export {
  TechSpaceErrorType
};
//# sourceMappingURL=index68.js.map
